import { Fade } from "react-awesome-reveal";
import Footer from "./Footer";
import Header from "./Header";

const publications = [
    {
        title: "Projektowanie pracowni kardiologii interwencyjnej – Od koncepcji do uruchomienia",
        journal: "DLASZPITALI.pl",
        year: "2026",
        type: "Raport medyczny",
        previewUrl: "https://res.cloudinary.com/dx9rdmmff/image/upload/pg_1,f_jpg,w_480,c_limit/v1792939808/Magda/hero/Projektowanie_pracowni_kardiologii_interwencyjnej_xcxq3e.pdf",
        url: "https://res.cloudinary.com/dx9rdmmff/image/upload/v1792939808/Magda/hero/Projektowanie_pracowni_kardiologii_interwencyjnej_xcxq3e.pdf",
    },
    {
        title: "Przyszłość inżynierii klinicznej w dobie AI na oddziałach intensywnej terapii",
        journal: "DLASZPITALI.pl",
        year: "2026",
        type: "Raport medyczny",
        previewUrl: "https://res.cloudinary.com/dx9rdmmff/image/upload/pg_1,f_jpg,w_480,c_limit/v1792939605/Magda/hero/Przysz%C5%82o%C5%9B%C4%87_in%C5%BCynierii_klinicznej_w_dobie_AI_mps7nu.pdf",
        url: "https://res.cloudinary.com/dx9rdmmff/image/upload/v1792939605/Magda/hero/Przysz%C5%82o%C5%9B%C4%87_in%C5%BCynierii_klinicznej_w_dobie_AI_mps7nu.pdf",
    },
    {
        title: "Gastroenterologia na bloku operacyjnym Czy infrastruktura bloku operacyjnego nadąża za rozwojem endoskopii zabiegowej?",
        journal: "DLASZPITALI.pl",
        year: "2026",
        type: "Raport medyczny",
        previewUrl: "https://res.cloudinary.com/dx9rdmmff/image/upload/pg_1,f_jpg,w_480,c_limit/v1792939606/Magda/hero/OPM_05_2026_net_261011_174834_mfxqjq.pdf",
        url: "https://res.cloudinary.com/dx9rdmmff/image/upload/v1792939606/Magda/hero/OPM_05_2026_net_261011_174834_mfxqjq.pdf",
    },
];

const Publications = () => {
    return (
        <div className="pub">
            <Fade className="fade_header" duration={2000}>
                <Header />
            </Fade>

            <div className="pub_main">
                <div className="pub_text">
                    <div className="pub_intro_copy">
                        <span className="pub_kicker">WIEDZA I PRAKTYKA</span>
                        <h2>Publikacje i materiały eksperckie</h2>
                        <p>
                            Zapraszam do zapoznania się z moimi publikacjami. Jest
                            mi niezmiernie miło dzielić się z Państwem wiedzą i
                            doświadczeniem zdobytym podczas realizacji projektów
                            obejmujących budowę, modernizację i wyposażenie
                            placówek medycznych.
                        </p>
                    </div>
                    <div className="pub_img" aria-label="Publikacje medyczne" />
                </div>

                <div className="pub_offer">
                    {publications.map(({ title, journal, year, type, previewUrl, url }, index) => {
                        const isLastOdd = publications.length % 2 !== 0 && index === publications.length - 1;

                        return (
                            <a
                                key={index}
                                href={url}
                                target="_blank"
                                rel="noreferrer"
                                className={`pub_item ${isLastOdd ? "pub_item_centered" : ""}`}
                            >
                                <div className="pub_thumbnail">
                                    <img src={previewUrl} alt="" loading="lazy" />
                                </div>

                                <div className="pub_item_content">
                                    <div className="pub_item_top">
                                        <span className="pub_number">
                                            {index + 1 < 10 ? `0${index + 1}` : index + 1}.
                                        </span>
                                        <span className="pub_type">{type}</span>
                                    </div>

                                    <h3>{title}</h3>
                                    <p className="pub_journal">{journal}</p>

                                    <div className="pub_meta">
                                        <span>{year}</span>
                                        <span>PDF</span>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>

                <p className="p_footer">
                    Mam nadzieję, że moje publikacje będą dla Państwa źródłem
                    praktycznej wiedzy, inspiracji lub po prostu ciekawą lekturą.
                </p>
            </div>

            <Footer />
        </div>
    );
};

export default Publications;
